import { Form, Select } from 'antd'
import { useMemo } from 'react'

export default function AppointmentAvailable({ fieldName, parameters }) {
  const available = useMemo(
    () => {
      const props = parameters?.properties
      if (!props) return []
      const arr = Array.isArray(props) ? props : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
      return arr.map(({ name }) => ({ label: name, value: name }))
    },
    [parameters]
  )

  return (
    <>
      <Form.Item
        label="Tipo de Agendamento"
        name={[fieldName, 'action', 'data', 'tipo']}
        rules={[{ required: true, message: 'Obrigatório' }]}
      >
        <Select options={available} placeholder="Selecione um parâmetro" />
      </Form.Item>
      <Form.Item
        label="Data Inicial"
        name={[fieldName, 'action', 'data', 'data_start']}
        rules={[{ required: true, message: 'Obrigatório' }]}
      >
        <Select options={available} placeholder="Selecione um parâmetro" />
      </Form.Item>
      <Form.Item
        label="Data Final"
        name={[fieldName, 'action', 'data', 'data_end']}
        rules={[{ required: true, message: 'Obrigatório' }]}
      >
        <Select options={available} placeholder="Selecione um parâmetro" />
      </Form.Item>
      <Form.Item label="ID da Especialidade" name={[fieldName, 'action', 'data', 'especialidade_id']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
      <Form.Item label="ID do Profissional" name={[fieldName, 'action', 'data', 'profissional_id']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
    </>
  )
}
